import type { Easing } from 'motion/react';

export const easeBounce: Easing = [0.25, 0.74, 0.22, 0.99];
export const easeCurve: Easing = [0.32, 0.72, 0, 1];
